import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import GlobalStyles from "./styles/globalStyles";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "../src/styles/theme";
import { store } from "./store/store";
import { Provider } from "react-redux";

import "@aws-amplify/ui-react/styles.css";

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyles />
    <ChakraProvider theme={theme}>
      <Provider store={store}>
        <App />
      </Provider>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
